<template>
  <div ref="bienvenidaRef" class="bienvenida-section">
    <!-- 🌸 FLORES DECORATIVAS EN LA ESQUINA SUPERIOR IZQUIERDA (APARECEN DE INMEDIATO) -->
    <img src="@/assets/esq-.png" class="flores-esquina-superior-izquierda" alt="Flores Decorativas Superior" />

    <div ref="encabezadoRef" class="encabezado-container">
      <p class="encabezado-fecha">30.DICIEMBRE.2026<br> – NUEVA APOLONIA</p><br>
      <h2 class="encabezado-nombres">
        <span class="nombre-principal">MARISA  </span><br>
        <span class="apellidos-novios">Hernández</span><br>
        <div class="separador-central">
            <div class="ampersand">&</div>
        </div>
        <span class="nombre-principal"> MARTÍN   </span><br>
        <span class="apellidos-novios">Morales</span>
      </h2>
    </div>

    <!-- 🌟 IMAGEN PAREJA ABAJO DE LOS NOMBRES -->
    <div ref="parejaContainerRef" class="pareja-imagen-container">
      <img src="@/assets/pareja.png" class="pareja-img" alt="Pareja Decorativa" />
    </div>

    <div class="bienvenida-container">
      <p ref="textoPrincipalRef" class="bienvenida-text">{{ mensaje }}</p>
      <p ref="nosCasamosRef" class="textmia">{{ mensajeFinal }}</p>

      <div ref="padresContainerRef" class="padres-container">
        <p ref="bendicionRef" class="bienvenida-text bendicion-text">
          Con la Bendición de Dios y en compañía de
        </p>

        <h3 class="padres-titulo" ref="padresTituloRef"><br /> NUESTROS PADRES</h3>
        <p
          v-for="(padre, i) in listaPadres"
          :key="'padre-' + i"
          class="padres-nombre"
          :ref="el => { if (el) padresRefs[i] = el }"
        >
          {{ padre }}
          <i v-if="padre.includes('Moises') || padre.includes('José')" class="fas fa-cross small-cross"></i>
        </p>

      </div>
    </div>

    <!-- 🌸 FLORES DECORATIVAS EN LA ESQUINA INFERIOR DERECHA (APARECEN DE INMEDIATO) -->
    <img src="@/assets/esqq.png" class="flores-esquina-derecha" alt="Flores Decorativas" />
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'BienvenidaPage',
  setup() {
    const bienvenidaRef = ref(null)
    const encabezadoRef = ref(null)
    const textoPrincipalRef = ref(null)
    const nosCasamosRef = ref(null)
    const padresTituloRef = ref(null)
    const padrinosTituloRef = ref(null)
    const padresContainerRef = ref(null)
    const padresRefs = ref([])
    const padrinosRefs = ref([])

    const bendicionRef = ref(null)
    const parejaContainerRef = ref(null)

    const mensaje = ref('')
    const mensajeFinal = ref('')

    const listaPadres = [
      'Moises Hernández',
      'Angelica Rodriguez',
      '&',
      ' José Morales',
      ' Bertha Victoria '
    ]

    const listaPadrinos = [
      'Mirna Álvarez Armijo ',
      'Romualdo Rodríguez de León  '
    ]

    const text = 'Hace 30 años nuestras almas se unieron en un mismo camino. Hoy, con la misma ilusión y un amor eterno, deseamos bendecir estas tres décadas de complicidad ante la presencia de Dios, renovando nuestra promesa de amarnos cada día.'
const textFinal = '¡Nuestra Promesa Continúa!'
    onMounted(async () => {
      await nextTick()

      // Ocultar elementos que SÍ llevan animación secuencial
      gsap.set([
        encabezadoRef.value,
        parejaContainerRef.value,
        textoPrincipalRef.value,
        nosCasamosRef.value,
        bendicionRef.value,
        padresTituloRef.value,
        padrinosTituloRef.value,
        ...padresRefs.value,
        ...padrinosRefs.value
      ], { opacity: 0, y: 40 })

      gsap.set(parejaContainerRef.value, { scale: 0.95 })

      // Animaciones al entrar en viewport
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } })

            // 1. Aparece el Encabezado con los Nombres
            tl.to(encabezadoRef.value, { y: 0, opacity: 1 }, 0)
              
              // 2. Animación consecutiva de pareja.png justo abajo de los nombres
              .to(parejaContainerRef.value, { y: 0, opacity: 1, scale: 1, duration: 1.2 }, '>-0.4')

              // 3. Animación de los Textos principales
              .add(() => { mensaje.value = text })
              .to(textoPrincipalRef.value, { y: 0, opacity: 1 }, '>-0.4')
              .add(() => { mensajeFinal.value = textFinal })
              .to(nosCasamosRef.value, { y: 0, opacity: 1 }, '>-0.5')

              // Animar la frase de bendición
              .to(bendicionRef.value, { y: 0, opacity: 1 }, '>-0.45')

              // Título PADRES + lista consecutiva
              .to(padresTituloRef.value, { y: 0, opacity: 1 }, '>-0.4')
              .to(padresRefs.value, {
                y: 0,
                opacity: 1,
                stagger: 0.25
              }, '>-0.2')

              // Título PADRINOS + lista consecutiva
              .to(padrinosTituloRef.value, { y: 0, opacity: 1 }, '>-0.2')
              .to(padrinosRefs.value, {
                y: 0,
                opacity: 1,
                stagger: 0.25
              }, '>-0.1')

            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.2 })

      if (bienvenidaRef.value) observer.observe(bienvenidaRef.value)
    })

    return {
      bienvenidaRef,
      encabezadoRef,
      textoPrincipalRef,
      nosCasamosRef,
      padresTituloRef,
      padrinosTituloRef,
      padresContainerRef,
      padresRefs,
      padrinosRefs,
      bendicionRef,
      parejaContainerRef,
      mensaje,
      mensajeFinal,
      listaPadres,
      listaPadrinos
    }
  }
}
</script>

<style scoped>
.small-cross {
  font-size: 0.8em;
  color: #a17e4e;
  margin-left: 4px;
}
.bienvenida-section {
  position: relative;
  padding: 30px 0;
  background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.franja-superior {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 0;
  overflow: hidden;
}

.ornamento-arriba {
  width: 260px;
  transform: translateX(-80px);
}

.encabezado-container {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 10px;
  opacity: 0;
  transform: translateY(50px);
  position: relative;
  z-index: 2;
}

.encabezado-fecha {
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  color: #555;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.encabezado-nombres {
  font-family: 'Playfair Display', serif;
  font-size: 32px;
  font-weight: bold;
  color: #1e1e1e;
  line-height: 1.2;
}

.nombre-principal {
  font-family: 'nombres';
  font-weight: 400;
}

.nombre-secundario {
  font-style: italic;
  margin-left: 5px;
}

.pareja-imagen-container {
  text-align: center;
  margin: 15px auto;
  opacity: 0;
  transform: translateY(40px);
  position: relative;
  z-index: 2;
}

.pareja-img {
  width: 100%;
  max-width: 140px;
  height: auto;
  display: inline-block;
}

.bienvenida-container {
  text-align: center;
  padding: 15px 20px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

.bienvenida-text {
  font-size: 18px;
  font-family: 'padres';
  color: #333;
  margin: 20px;
  transform: translateY(20px);
  opacity: 0;
  white-space: pre-line;
}

.bendicion-text {
  margin-top: 10px;
  margin-bottom: 10px;
}

.textmia {
  font-family: "say2";
  font-size: 26px;
  color: #30302f;
  margin-top: 20px;
  opacity: 0;
}

.padres-container {
  margin-top: 20px;
  text-align: center;
}
.separador-central {
  text-align: center;
  margin: 10px 0;
}

.imagen-separador {
  width: 150px;
  height: auto;
  margin-top:10px;
  margin-bottom:10px;
  filter: brightness(0.4) contrast(1.2);
  opacity: 0.8;
}

.padres-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 1.5;
  margin-bottom: 20px;
  letter-spacing: 1px;
}
.apellidos-novios {
  font-size: 30px;
  font-family: "Hearth Stone", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: #9b9898;
}
.padres-nombre {
  font-family: 'padres', serif;
  font-size: 16px;
  color: #444;
  margin-bottom: 8px;
  opacity: 0;
}

.ampersand {
  font-size: 30px;
  line-height: 0.8;
  color: rgb(93, 89, 89);
  opacity: 0.25;
  margin-top:18px;
  margin-bottom: 18px;
  font-family: 'padres', serif;
}

/* ==========================================================================
   ESTILOS AGREGADOS: IMÁGENES FLORES (SIN ANIMACIÓN - CARGA INMEDIATA)
   ========================================================================== */
.flores-esquina-superior-izquierda {
  position: absolute;
  top: 0;
  left: 0;
  width: min(100px, 20vw);
  height: auto;
  pointer-events: none;
  z-index: 10;
  display: block;
  opacity: 1 !important; /* Salta la animación de GSAP */
}

.flores-esquina-derecha {
  position: absolute;
  bottom: 0;
  right: 0;
  width: min(180px, 45vw);
  height: auto;
  pointer-events: none;
  z-index: 10;
  display: block;
  opacity: 1 !important; /* Salta la animación de GSAP */
}
</style>